import { get } from './request';

const INVALID_CATEGORY_SLUGS = ['bebidas'];

export const getAdCssBackgroundColorProp = (
  [bgColor1, bgColor2] = [null, null]
) =>
  !bgColor2
    ? bgColor1
    : `linear-gradient(45deg, ${bgColor1} 0% 50%, ${bgColor2} 50% 100%)`;

export const getTopbarAd = async () => {
  try {
    const {
      data: {
        topAd: [topbarAd = null],
      },
    } = await get('/ads?type=TOP_AD');

    return topbarAd;
  } catch (e) {
    return null;
  }
};

export const isOfferCategorySlugValidToActivateGoogleAd = (slug) =>
  !INVALID_CATEGORY_SLUGS.some((invalidSlug) => invalidSlug === slug);
